import { Base } from '@testsigma/organism';
import { deserialize, serializable } from 'serializr';

export class PlatformBrowserVersion extends Base {
  @serializable
  id: number;
  @serializable
  name: string;
  @serializable
  version: string;
  @serializable
  displayVersion: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(PlatformBrowserVersion, input));
  }
}
